import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';

// Site-wide nav, shared by the top bar on every public page. Kept to the two
// other properties in the timing.kiwi family — this app (Results) is where
// you already are, so it isn't listed as a destination.
const links = [
  { label: 'Results', href: 'https://live.timing.kiwi' },
  { label: 'GPS Tracking', href: 'https://track.timing.kiwi' },
];

const SiteMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        aria-label="Site menu"
        aria-controls={open ? 'site-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="site-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {links.map(({ label, href }) => (
          <MenuItem key={href} component="a" href={href} onClick={() => setAnchorEl(null)}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SiteMenu;
